export const marquee = () => {
  if (window.innerWidth < 991) {
    const marqueeContent = document.querySelector(".topbar__list");
    const marqueeItems = marqueeContent.innerHTML;

    for (let i = 0; i < 3; i++) {
      marqueeContent.innerHTML += marqueeItems;
    }
    const contentWidth = marqueeContent.scrollWidth;
    marqueeContent.style.width = `${contentWidth}px`;
  }
};
